import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { List, Row, Cell } from '../../../components/List';
import { VBox } from '../../../components/Box';
import { REQUEST_INVOICE_STATUS_LIST } from "../constants";
import { fetchStatuses } from "../actions";
import { Loader } from "../../../components/Loader";
import { selectWorks } from "../../Api/selectors";

const Container = styled.div`
  max-height: 60vh;
  overflow-y: auto;
`;

const STATE = {};

/* eslint-disable react/prefer-stateless-function */
class StatusSelectionComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    this.fetchItems();
  }

  mapItem(i) {
    return {
      id: i.id,
      label: i.name,
    };
  }

  fetchItems() {
    this.props.fetchItems(result => {
      this.setState({
        result: result.map(this.mapItem),
      })
    })
  }

  get items() {

    return this.state.result ?? [];
  }

  render() {
    return (
      <Container>
        <VBox>
          {this.renderItems()}
        </VBox>
      </Container>
    );
  }

  renderItems() {
    if (this.props.work) return <Loader small />;
    if (!this.items || this.items?.length === 0) return 'No items';

    return (
      <div className="results">
        <List>
          {this.items.map(i => (
            <Row key={i.id} onClick={() => this.props.onSelect?.(i)}>
              <Cell> {this.lbl('translate.'+ i.label)}</Cell>
            </Row>
          ))}
        </List>
      </div>
    );
  }
}

StatusSelectionComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([REQUEST_INVOICE_STATUS_LIST]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetchItems: (callback) => {
      dispatch(fetchStatuses(callback));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const StatusSelection = compose(
  withConnect,
  withRouter,
)(StatusSelectionComp);
